"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var styles = function styles(theme) {
  if (!("scrollbars" in theme)) {
    theme.scrollbars = {
      main: {}
    };
  }

  return {
    listItem: {
      textTransform: "none",
      letterSpacing: "0",
      padding: ".8rem 2rem",
      "&:hover": {
        background: theme.palette.action.hover
      }
    },
    root: {
      zIndex: "2"
    },
    canBeClicked: {
      cursor: "pointer"
    },
    iconContainer: {
      margin: "auto",
      display: "flex",
      alignItems: "center",
      minHeight: theme.mixins.toolbar.minHeight,
      "& > svg": {
        maxHeight: "1rem",
        padding: "0 0 0 2rem",
        maxWidth: "100%",
        width: "100%",
        zIndex: "2"
      }
    },
    arrowContainer: {
      right: "1rem",
      position: "absolute",
      zIndex: 2,
      "& svg": {
        transition: "transform 240ms"
      }
    },
    arrowContainerOpen: {
      "& svg": {
        transform: "scaleY(-1)"
      }
    },
    container: {
      backgroundColor: theme.palette.grey[100],
      borderBottom: "1px solid ".concat(theme.palette.grey[200])
    },
    selected: {
      color: theme.palette.text.secondary,
      fontSize: "1rem",
      padding: "1rem 2rem",
      paddingRight: "5rem",
      fontWeight: "600",
      userSelect: "none"
    },
    menu: {
      position: "relative",
      zIndex: "-1"
    },
    list: _objectSpread((0, _defineProperty2.default)({
      position: "absolute",
      background: theme.palette.background.paper,
      left: "0",
      right: "0",
      padding: theme.spacing(2, 0),
      borderBottom: "solid .33rem " + theme.palette.primary.main,
      maxHeight: "calc(100vh - 191px)"
    }, theme.breakpoints.up("sm"), {
      maxHeight: "calc(100vh - 220px)"
    }), theme.scrollbars.main)
  };
};

exports.styles = styles;